import { Button, Container, HStack, Input, VStack, border, calc ,Stack} from '@chakra-ui/react';
import React from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';


const Upload = () => {
  return (
    <Container h={"100vh"} maxWw={"container.xl"} p={"16"}>
        <VStack justifyContent={"center"} h={"full"} color={"purple.500"} alignItems={"center"}>
            <AiOutlineCloudUpload size={"150"}/>
            <Stack direction={["column","row"]}>
            <Input type='file' css={{
                "&::file-selector-button":{
                    border:"none",
                    width:"calc(100% + 36px)",
                    marginLeft:"-18px",
                    height:"100%",
                    cursor:"pointer",
                    backgroundColor:'white',
                    color:'purple',
                }
            }}/>
            <Button colorScheme='purple'>Upload</Button>
            </Stack>
        </VStack>
    </Container>
  )
}

export default Upload